import { useEffect, useMemo, useState } from "react";
import { format } from "date-fns";
import {
  useObtenerFacturasPortalQuery,
  useObtenerSociedadesPortalQuery,
} from "src/services/portalMultisociedadApi";

const DEMORA_BUSQUEDA_MS = 350;
const RESUMEN_VACIO = Object.freeze({
  totalPagado: 0,
  totalPendiente: 0,
  totalOtros: 0,
  cantidadPagadas: 0,
  cantidadPendientes: 0,
  cantidadOtros: 0,
  totalGeneral: 0,
  cantidadTotal: 0,
});

const fechaApi = (valor) => (valor ? format(valor, "yyyy-MM-dd") : undefined);

const numeroApi = (valor) =>
  valor === "" || valor === null || valor === undefined
    ? undefined
    : Number(valor);

export function useFacturasMultisociedad({
  filtros,
  mostrarAnuladas,
  order,
  orderBy,
  page,
  rowsPerPage,
  rutSociedad,
}) {
  const [busqueda, setBusqueda] = useState(filtros.busqueda);

  useEffect(() => {
    const timeout = setTimeout(
      () => setBusqueda(filtros.busqueda),
      DEMORA_BUSQUEDA_MS,
    );
    return () => clearTimeout(timeout);
  }, [filtros.busqueda]);

  const sociedadesQuery = useObtenerSociedadesPortalQuery();
  const parametros = useMemo(
    () => ({
      rutSociedad: rutSociedad || undefined,
      tipoFactura: filtros.tipoFactura || undefined,
      busqueda: busqueda?.trim() || undefined,
      estados: filtros.estados?.length ? filtros.estados.join(",") : undefined,
      fechaFacturacionDesde: fechaApi(filtros.fechaFacturacionDesde),
      fechaFacturacionHasta: fechaApi(filtros.fechaFacturacionHasta),
      montoMin: numeroApi(filtros.montoMin),
      montoMax: numeroApi(filtros.montoMax),
      incluirAnuladas: mostrarAnuladas,
      ordenPor: orderBy || undefined,
      orden: order,
      pagina: page + 1,
      limite: rowsPerPage,
    }),
    [
      busqueda,
      filtros.estados,
      filtros.fechaFacturacionDesde,
      filtros.fechaFacturacionHasta,
      filtros.montoMax,
      filtros.montoMin,
      filtros.tipoFactura,
      mostrarAnuladas,
      order,
      orderBy,
      page,
      rowsPerPage,
      rutSociedad,
    ],
  );

  const facturasQuery = useObtenerFacturasPortalQuery(parametros, {
    skip:
      rutSociedad === null ||
      sociedadesQuery.isLoading ||
      sociedadesQuery.isError,
    refetchOnMountOrArgChange: true,
  });

  return {
    sociedades: sociedadesQuery.data?.sociedades ?? [],
    facturas: facturasQuery.currentData?.facturas ?? [],
    paginacion: facturasQuery.currentData?.paginacion,
    resumen: facturasQuery.currentData?.resumen ?? RESUMEN_VACIO,
    isLoading:
      sociedadesQuery.isLoading ||
      facturasQuery.isLoading ||
      (!facturasQuery.currentData && facturasQuery.isFetching),
    isFetching: facturasQuery.isFetching,
    isError: sociedadesQuery.isError || facturasQuery.isError,
    isForbidden:
      sociedadesQuery.error?.status === 403 ||
      facturasQuery.error?.status === 403,
  };
}
